import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';

import Block from './Block';
import H2 from './H2';
import EventsList from './EventsList';

const PageEvents = ({ content, selectedLocale }) => (
  <Block
    id={content.primary.internal_link_id}
    py={{ mobile: 'baseUp4', tablet: 'baseUp12' }}
  >
    <H2
      textAlign="center"
      mb={{ mobile: 'baseUnit', tablet: 'baseUp10' }}
      color="coral"
    >
      {content.primary.title1.text}
    </H2>

    <EventsList selectedLocale={selectedLocale} withTitle={false} />
  </Block>
);

PageEvents.propTypes = {
  content: PropTypes.shape({
    primary: PropTypes.shape({
      internal_link_id: PropTypes.string,
      title1: PropTypes.shape({ text: PropTypes.string }),
    }),
  }).isRequired,
  selectedLocale: PropTypes.string.isRequired,
};

export default PageEvents;

export const query = graphql`
  fragment PageEventsFragment on PrismicPageBodyEvents {
    id
    slice_type
    primary {
      internal_link_id
      title1 {
        text
      }
    }
  }
`;
